export default __webpack_public_path__ + "static/heat_exchanger_w.9952871f1fbf0dfc763bfbdc2976541d.png";